module.exports = __webpack_public_path__ + "static/media/parampage-bg2.4c3b916d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/parampage-bg2.png
// module id = 1140
// module chunks = 0